<template>
  <div class="box9">
    <pageTitle title="学员专享服务" />

    <div class="content">
      <div
        class="demo"
        v-for="(item, index) in list"
        :key="index"
        :style="{ background: '#' + list[index].color }"
      >
        <div class="title">
          <img
            :src="
              require(`../../../assets/coursePage/cPuls/box9/0${index + 1}.png`)
            "
            alt
          />
          {{ item.title }}
        </div>
        <div class="text" v-html="item.text"></div>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      list: [
        {
          title: "课程内容全解锁",
          color: "f8fff7",
          text: "有基础的学员，可选择性学习自己薄弱的知<br />识点或者当前公司项目需要用到的技术点",
        },
        {
          title: "个性化定制学习计划",
          color: "fff9f6",
          text: "智能学习系统科学制定专属学习计划，并根<br />据实际学习情况及时督促学习",
        },
        {
          title: "技术答疑不等待",
          color: "f9f6ff",
          text: "7*24小时学习小助手实时答疑<br />每周二、三、五、六14:00—20:00每周四<br />16:00—22:00技术导师答疑",
        },
        {
          title: "学习机制",
          color: "f6faff",
          text: "提供最新视频及笔记、讲义、源代码等全套<br />资料，服务期内享受课程更新<br />笔记和源代码等可通过平台下载",
        },
        {
          title: "测评作业批阅",
          color: "fffcf6",
          text: "课程中配置的阶段作业或单元测评，学生提<br />交后导师及时批阅或反馈",
        },
        {
          title: "就业指导",
          color: "fff8f6",
          text: "提供制定个性化就业方案，包括：简历书写<br />与修改、模拟面试和技术能力反馈、复习计<br />划等",
        },
      ],
    };
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.box9 {
  padding: 80px 0px 88px;

  width: 100%;
  background: #ffffff;

  .content {
    margin: 48px auto 0;
    padding: 36px 30px;
    width: 690px;
    background-color: #ffffff;
    background-color: #ffffff;
    box-shadow: 0px 8px 29px 0px rgba(0, 129, 255, 0.25);
    border-radius: 12px;
    border: solid 1px #ffffff;
    box-sizing: border-box;

    .demo {
      margin-bottom: 30px;
      padding: 32px;
      width: 100%;
      border-radius: 12px;
      box-sizing: border-box;

      .title {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        font-family: PingFangSC-Medium;
        font-size: 28px;
        font-weight: bold;
        font-stretch: normal;
        line-height: 36px;
        letter-spacing: 0px;
        color: #191c47;
        img {
          margin-right: 32px;
        }
      }

      .text {
        padding-left: 82px;
        font-family: PingFang SC;
        font-size: 24px;
        font-weight: normal;
        line-height: 40px;
        letter-spacing: 0px;
        color: #666666;
      }

      &:nth-child(1) {
        img {
          width: 50px;
          height: 49px;
        }
      }
      &:nth-child(2) {
        img {
          width: 49px;
          height: 50px;
        }
      }
      &:nth-child(3) {
        img {
          width: 50px;
          height: 46px;
        }
      }
      &:nth-child(4) {
        img {
          width: 45px;
          height: 50px;
        }
      }
      &:nth-child(5) {
        img {
          width: 51px;
          height: 49px;
        }
      }
      &:nth-child(6) {
        img {
          width: 51px;
          height: 49px;
        }
      }
    }
    .demo:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
